import React from "react";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import "./style.css";

function BusinessCard() {
  return (
    <div className="bc-page">
      <button
        className="bc-print-btn no-print"
        onClick={() => window.print()}
      >
        Print / Save as PDF
      </button>

      <div className="bc-card">
        <div className="bc-ring bc-ring-one"></div>
        <div className="bc-ring bc-ring-two"></div>
        <div className="bc-dots"></div>

        <div className="bc-top">
          <img src="/img/logoFooter.svg" alt="Lozrian" className="bc-logo" />
          <span className="bc-tagline">Trading &amp; Business Solutions</span>
        </div>

        <div className="bc-body">
          <h1 className="bc-name">Kateryna Shapoval</h1>
          <p className="bc-title">Co-Founder &amp; Director</p>
        </div>

        <div className="bc-divider"></div>

        <div className="bc-contact">
          <a href="tel:+380502484053" className="bc-contact-item">
            <FaPhoneAlt />
            <span>+380 50 248 4053</span>
          </a>
          <a href="mailto:ks@lozrian.com" className="bc-contact-item">
            <FaEnvelope />
            <span>ks@lozrian.com</span>
          </a>
        </div>

        <div className="bc-badge">
          <span className="bc-badge-label">Specialized Supply</span>
          <span className="bc-badge-value">Global Marine Lubricants</span>
        </div>
      </div>
    </div>
  );
}

export default BusinessCard;
